import { onBeforeUnmount, onMounted, reactive, readonly } from "vue";
import { detectDevice, type DeviceInfo } from "@os1/core/device";

/**
 * Vue wrapper around `@os1/core/device.detectDevice()`.
 *
 * Detection logic lives in the shared package so apps/web and apps/mobile
 * agree on what counts as mobile vs desktop and where to route installs.
 * This composable just makes that result reactive across resize / orientation.
 */

const state = reactive<DeviceInfo>(detectDevice());

let mounted = 0;

const refresh = () => {
  const next = detectDevice();
  state.class = next.class;
  state.os = next.os;
  state.isTouch = next.isTouch;
  state.isStandalone = next.isStandalone;
  state.installTarget = next.installTarget;
};

const onChange = () => refresh();

export function useDevice() {
  onMounted(() => {
    mounted += 1;
    if (mounted === 1) {
      refresh();
      window.addEventListener("resize", onChange, { passive: true });
      window.addEventListener("orientationchange", onChange, { passive: true });
    }
  });

  onBeforeUnmount(() => {
    mounted -= 1;
    if (mounted === 0) {
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    }
  });

  return readonly(state);
}
